import { Position, Player } from '../../types/Game';
import * as _ from 'lodash';

const getPlayerInPosition = (position: Position, players: Array<Player>): Player | null => {

    const player = _.find(players, (player => {
        return player.position.x === position.x && player.position.y === position.y
    }));

    return player ? player : null;
}

const getDiceSideNumbers = (numberOfDices: number): Array<number> => {
    const diceNumbers = [];
    for (let i = 0; i < numberOfDices; i++) {
        diceNumbers.push(_.random(1, 6));
    }
    return diceNumbers;
}


export default { getPlayerInPosition, getDiceSideNumbers }